const footerLinks = [
  {
    title: '快速导航',
    items: [
      { label: '焦点爆料', href: '#carousel' },
      { label: '热门专题', href: '#index' },
      { label: '最新爆料', href: '#updates' },
      { label: '深度吃瓜', href: '#cards' },
      { label: '吃瓜热榜', href: '#ranking' },
    ],
  },
  {
    title: '服务支持',
    items: [
      { label: '投稿爆料', href: '#contact' },
      { label: '手机吃瓜', href: '#app' },
      { label: '常见问题', href: '#faq' },
      { label: '关于我们', href: '#about' },
      { label: '瓜友热评', href: '#comments' },
    ],
  },
  {
    title: '合作伙伴',
    items: [],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-200/70 border-t border-background-300/60">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-heading text-lg">
                瓜
              </span>
              <span className="font-heading text-xl text-foreground-950">91吃瓜爆料网</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              国内领先的吃瓜群众专属娱乐八卦资讯聚合平台。7×24小时实时追踪全网热点，深度挖掘娱乐圈幕后真相，为百万吃瓜群众提供最新、最全、最快的爆料内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-300/60 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-300/60 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-8 h-8 flex items-center justify-center rounded-md bg-background-300/60 text-foreground-500 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          {/* Link Groups */}
          {footerLinks.map((group, gIdx) => (
            <div key={gIdx}>
              <h4 className="text-sm font-medium text-foreground-900 mb-3">{group.title}</h4>
              {group.items.length > 0 ? (
                <ul className="space-y-2">
                  {group.items.map((link, lIdx) => (
                    <li key={lIdx}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleClick(link.href); }}
                        className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-foreground-400">诚邀优质站点合作</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 91吃瓜爆料网. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">服务条款</a>
            <a href="#hero" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}